import React from "react";
import MaxWidthContainer from "@src/components/containers/MaxWidthContainer";

export default function SupportComingSoonPage(): React.JSX.Element {
  return (
    <MaxWidthContainer>
      <div
        className="spaced-content-xl"
        style={{ textAlign: "center", paddingTop: "4rem" }}
      >
        <h1>Support Portal</h1>
        <p>This portal is coming soon.</p>
      </div>
    </MaxWidthContainer>
  );
}
